<template>
  <ForgotPasswordFormProfessional />
</template>
<script>
import ForgotPasswordFormProfessional from "@/components/Login/ForgotPasswordForms/FormForgotPasswordProfessional";

export default {
  name: "ForgotPassword",
  components: {
    ForgotPasswordFormProfessional
  }
};
</script>
